import { Loader2 } from "lucide-react";
import clsx from "clsx";

export type LoaderProps = {
  size?: "sm" | "md" | "lg";
  label?: string;
  inline?: boolean;
  tone?: "brand" | "muted" | "inverse";
  className?: string;
};

const sizeMap = { sm: 14, md: 20, lg: 28 };
const toneMap = {
  brand: "text-[var(--color-accent)]",
  muted: "text-[var(--color-text-secondary)]",
  inverse: "text-[var(--color-text-inverse)]",
};

export function Loader({ size = "md", label, inline, tone = "brand", className }: LoaderProps) {
  const ariaLabel = label ?? "Loading";
  return (
    <span
      role="status"
      aria-label={ariaLabel}
      className={clsx(
        "items-center gap-2 text-sm",
        inline ? "inline-flex" : "flex",
        toneMap[tone],
        className,
      )}
    >
      <Loader2 size={sizeMap[size]} className="animate-spin" aria-hidden />
      {label && <span>{label}</span>}
    </span>
  );
}
